export default {
    namespaced: true,
    state: {
		title: '',
		params: {
			mode: 'RegionKindBrend',
			datebegin: null,
			dateend: null,
			category: null,
			brand: null,
			model: null,
			region: null,
			city: null,
		},
		items: [],
        /* data: {
			datasets: {
				ds: []
			}
		}, */
    },
}